import { render, staticRenderFns } from "./MTagDialog.vue?vue&type=template&id=6a819106&scoped=true&"
import script from "./MTagDialog.vue?vue&type=script&lang=js&"
export * from "./MTagDialog.vue?vue&type=script&lang=js&"
import style0 from "./MTagDialog.vue?vue&type=style&index=0&id=6a819106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a819106",
  null
  
)

export default component.exports